import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-stock-detail',
  templateUrl: './stock-detail.component.html',
  styleUrls: ['./stock-detail.component.css']
})
export class StockDetailComponent implements OnInit {

  constructor(private AdviceService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  name=""
  output:any=[];
  Id:any=""
  //-------date formating-------------
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe:any= null;
  
  DateFormat(value:any){
    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    return this.todayWithPipe
  }
  productDetails(){
    this.router.navigateByUrl(('admin/product-details'));  
  }
  //--------function which give name of selected item---------
  getValue = (item : string) =>{
     
    this.AdviceService.setProductId(item)
    
  }
    ngOnInit(): void {
  
      this.Id=localStorage.getItem('stock_id');
      this.AdviceService.ListStockEach(this.Id).subscribe((res)=>{
        this.output=res.data
        })
    }
  
  }
  
